import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext';
import ProtectedRoute from './components/ProtectedRoute';
import CookieConsent from './components/CookieConsent';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import TippspielOverview from './pages/TippspielOverview';
import TippspielSubmit from './pages/TippspielSubmit';
import TippspielLeaderboard from './pages/TippspielLeaderboard';
import TippspielMyTips from './pages/TippspielMyTips';
import TippspielStats from './pages/TippspielStats';
import AdminSettings from './pages/AdminSettings';
import AccountSettings from './pages/AccountSettings';
import Teilnahmebedingungen from './pages/legal/Teilnahmebedingungen';
import Datenschutz from './pages/legal/Datenschutz';
import CookieRichtlinien from './pages/legal/CookieRichtlinien';

const routerBasename = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

function App() {
  return (
    <AuthProvider>
      <CookieConsentProvider>
        <BrowserRouter basename={routerBasename}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/passwort-vergessen" element={<ForgotPassword />} />
            <Route path="/passwort-reset" element={<ResetPassword />} />
            <Route path="/teilnahmebedingungen" element={<Teilnahmebedingungen />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/cookie-richtlinien" element={<CookieRichtlinien />} />
            <Route path="/uebersicht" element={
              <ProtectedRoute><Layout><TippspielOverview /></Layout></ProtectedRoute>
            } />
            <Route path="/tippen" element={
              <ProtectedRoute><Layout><TippspielSubmit /></Layout></ProtectedRoute>
            } />
            <Route path="/rangliste" element={
              <ProtectedRoute><Layout><TippspielLeaderboard /></Layout></ProtectedRoute>
            } />
            <Route path="/meine-tipps" element={
              <ProtectedRoute><Layout><TippspielMyTips /></Layout></ProtectedRoute>
            } />
            <Route path="/statistik" element={
              <ProtectedRoute><Layout><TippspielStats /></Layout></ProtectedRoute>
            } />
            <Route path="/konto" element={
              <ProtectedRoute><Layout><AccountSettings /></Layout></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute adminOnly><Layout><AdminSettings /></Layout></ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </CookieConsentProvider>
    </AuthProvider>
  );
}

export default App;
